import type { ExploreSection, ExploreSubSection } from "@/types";
import type { ServiceResponse } from "./api.types";
import { privateAPI } from "./axios";

// API functions for managing Explore sections (blog/research articles)
// These connect the admin UI to the Laravel backend

export const getExploreSections = async (): Promise<
  ServiceResponse<ExploreSection[]>
> => {
  const response =
    await privateAPI.get<ServiceResponse<ExploreSection[]>>("/explore");
  return response.data;
};

export const getExploreSection = async (
  id: string,
): Promise<ServiceResponse<ExploreSection>> => {
  const response = await privateAPI.get<ServiceResponse<ExploreSection>>(
    `/explore/${id}`,
  );
  return response.data;
};

export const createExploreSection = async (
  data: Partial<ExploreSection> & { image_extension?: string },
): Promise<ServiceResponse<ExploreSection>> => {
  const response = await privateAPI.post<ServiceResponse<ExploreSection>>(
    "/explore",
    data,
  );
  return response.data;
};

export const updateExploreSection = async (
  id: string,
  data: Partial<ExploreSection> & { image_extension?: string },
): Promise<ServiceResponse<ExploreSection>> => {
  const response = await privateAPI.put<ServiceResponse<ExploreSection>>(
    `/explore/${id}`,
    data,
  );
  return response.data;
};

export const deleteExploreSection = async (id: string): Promise<void> => {
  await privateAPI.delete(`/explore/${id}`);
};

export const createExploreSubSection = async (
  data: Partial<ExploreSubSection> & { image_extension?: string },
): Promise<ServiceResponse<ExploreSubSection>> => {
  const response = await privateAPI.post<ServiceResponse<ExploreSubSection>>(
    "/explore/sub-sections",
    data,
  );
  return response.data;
};

export const updateExploreSubSection = async (
  id: string,
  data: Partial<ExploreSubSection> & { image_extension?: string },
): Promise<ServiceResponse<ExploreSubSection>> => {
  const response = await privateAPI.put<ServiceResponse<ExploreSubSection>>(
    `/explore/sub-sections/${id}`,
    data,
  );
  return response.data;
};

export const deleteExploreSubSection = async (id: string): Promise<void> => {
  await privateAPI.delete(`/explore/sub-sections/${id}`);
};

export const getSectionImageUploadUrl = async (
  sectionId: string,
  fileName: string,
): Promise<ServiceResponse<{ url: string; key: string }>> => {
  const response = await privateAPI.get<
    ServiceResponse<{ url: string; key: string }>
  >(`/explore/${sectionId}/image/upload-url`, { params: { fileName } });
  return response.data;
};

export const getSubSectionImageUploadUrl = async (
  subSectionId: string,
  fileName: string,
): Promise<ServiceResponse<{ url: string; key: string }>> => {
  const response = await privateAPI.get<
    ServiceResponse<{ url: string; key: string }>
  >(`/explore/sub-sections/${subSectionId}/image/upload-url`, {
    params: { fileName },
  });
  return response.data;
};
